import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import { __decorate } from "tslib";
import { defaultLedgerData, getLedgerById, updateLedgerItemWise } from '@/api/ledgers';
import router from '@/router';
import { AppModule } from '@/store/modules/app';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-module-decorators';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultLedgerData);
    this.listLoading = false;
    this.loading = false;
    this.id = null;
    this.paymentTypeOptions = [{
      label: 'Cash in Bank',
      key: 'Cash in Bank'
    }, {
      label: 'Cheque',
      key: 'Cheque'
    }, {
      label: 'Net Banking',
      key: 'Net Banking'
    }, {
      label: 'Credit Note',
      key: 'Credit Note'
    }, {
      label: 'Debit Note',
      key: 'Debit Note'
    }, {
      label: 'Credit Note-Item Wise',
      key: 'Credit Note-Item Wise'
    }, {
      label: 'Debit Note-Item Wise',
      key: 'Debit Note-Item Wise'
    }, {
      label: 'Journal Receipt',
      key: 'Journal Receipt'
    }, {
      label: 'Goods Inwards',
      key: 'Purchase'
    }, {
      label: 'Credit Note Inward',
      key: 'Credit Note Inward'
    }];
    this.paymentSubTypeOptions = [{
      label: 'Difference in Discount (Sales)',
      key: 'Difference in Discount (Sales)'
    }, {
      label: 'Difference in Rates (Sales)',
      key: 'Difference in Rates (Sales)'
    }, {
      label: 'Special Scheme Discount',
      key: 'Special Scheme Discount'
    }, {
      label: 'Trade Discount Given',
      key: 'Trade Discount Given'
    }, {
      label: 'Difference in Discount (Purchase)',
      key: 'Difference in Discount (Purchase)'
    }, {
      label: 'Difference in Rates (Purchase)',
      key: 'Difference in Rates (Purchase)'
    }, {
      label: 'Trade Discount Received',
      key: 'Trade Discount Received'
    }, {
      label: 'Other',
      key: 'Other'
    }];
    this.accountManagers = {
      1: 'SUPER ADMIN',
      27: 'SONAM JAISWAR',
      21: 'SUMIT LINGAVE',
      22: 'SNEHA SHIVGAN',
      42: 'RAM ROHRA',
      43: 'DEEPAK KHIRTALA',
      44: 'TUSHAR CHAVAN'
    };
  }
  activated() {
    if (this.$route.params && this.$route.params.id) {
      const id = this.$route.params && this.$route.params.id;
      this.id = +id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultLedgerData);
    }
  }
  get lang() {
    return AppModule.language;
  }
  async fetchData(id) {
    if (id) {
      const data = await getLedgerById(id);
      this.formData = data;
    }
  }
  handleRowChange(row) {
    if (row) {
      const mrp = +row.mrp;
      // Apply discounts sequentially
      let discountedPrice = mrp;
      discountedPrice -= discountedPrice * (+row.policiesDiscount || 0) / 100;
      discountedPrice -= discountedPrice * (+row.schemesDiscount || 0) / 100;
      discountedPrice -= discountedPrice * (+row.moqDiscount || 0) / 100;
      discountedPrice -= discountedPrice * (+row.extraDiscount || 0) / 100;
      row.nettRate = discountedPrice;
      row.subTotal = (+row.nettRate * +row.quantity).toFixed(2);
      row.taxedAmount = (+row.nettRate * +row.quantity * 0.18).toFixed(2);
      row.discountAmount = ((mrp - +discountedPrice) * +row.quantity).toFixed(2);
      // Update the total amount
      let totalAmount = 0;
      totalAmount = this.formData.ledgersItemWise.reduce((acc, row) => acc + (+row.subTotal || 0) + (+row.taxedAmount || 0), 0);
      this.formData.amount = totalAmount;
    }
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  async saveForm() {
    try {
      this.loading = true;
      // update ledger
      if (this.id) {
        this.formData.id = this.id;
        await updateLedgerItemWise(this.formData);
        router.push('/ledgers/list');
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
      console.log('error', error);
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'EditItemWiseLedger',
  components: {}
})], default_1);
export default default_1;